import { motion } from "framer-motion";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQS } from "@/lib/data";

export default function FAQs() {
  return (
    <section data-testid="faqs-section" className="py-24 md:py-32 bg-secondary/30 dark:bg-secondary/10">
      <div className="max-w-4xl mx-auto px-6 md:px-8">
        <div className="text-center mb-12">
          <div className="text-xs tracking-[0.25em] uppercase text-[#D4AF37] font-bold mb-4">Frequently Asked</div>
          <h2 className="text-4xl sm:text-5xl font-light tracking-tighter">
            Answers to your <span className="font-serif italic text-gradient-royal">big questions.</span>
          </h2>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <Accordion type="single" collapsible className="space-y-3">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="border border-border rounded-2xl px-5 bg-card data-[state=open]:border-[#D4AF37]/60 data-[state=open]:shadow-md transition-all"
              >
                <AccordionTrigger className="text-left font-heading font-medium text-base sm:text-lg hover:no-underline py-5">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground leading-relaxed pb-5">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
}
